import { Avatar, Skeleton, Tooltip } from "@mui/material";
import { useState } from "react";
import { onDragStart } from "utilities/dragndrop";
import ErrorIcon from "@mui/icons-material/Error";
import { deepOrange } from "@mui/material/colors";

type IProps = {
  src: string;
  alt: string;
};

const AvatarImage = (props: IProps) => {
  const [loaded, setLoaded] = useState<boolean>(false);
  const [failed, setFailed] = useState<boolean>(false);

  return (
    <>
      {!loaded && <Skeleton variant="rectangular" width={40} height={40} />}
      {!failed && (
        <Avatar
          classes={{ img: 'is-checkered-background' }}
          alt={props.alt}
          variant="square"
          src={props.src}
          onLoad={() => {
            setLoaded(true);
          }}
          sx={{
            height: '70px',
            width: '72px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            overflow: 'hidden',
          }}
          // @ts-ignore
          onError={(e) => {
            setFailed(true);
            setLoaded(true);
          }}
          draggable={!failed && loaded}
          onDragStart={(e: {
            dataTransfer: { dropEffect: string; effectAllowed: string };
          }) => onDragStart(props.src, props.alt, e)}
        />
      )}
      {failed && (
        <Tooltip title="Failed to load image">
          <Avatar sx={{ bgcolor: deepOrange[500] }} variant="rounded">
            <ErrorIcon />
          </Avatar>
        </Tooltip>
      )}
    </>
  );
};

export default AvatarImage;
